import { render, staticRenderFns } from "./wxGameDetail.vue?vue&type=template&id=781a850e"
import script from "./wxGameDetail.vue?vue&type=script&lang=js"
export * from "./wxGameDetail.vue?vue&type=script&lang=js"
import style0 from "./wxGameDetail.vue?vue&type=style&index=0&id=781a850e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports